<template>
    <!--
    <div class="mt-2 space-y-1">
        
        <div class="grid grid-cols-4 gap-1">
            <div class="text-center">
                <svg-icon type="mdi" :path="isOnline ? mdiCheckCircle : mdiCloseCircle" 
                         :class="isOnline ? 'text-success' : 'text-error'" size="12"/>
                <div class="text-xs font-medium" :class="batteryColor">{{ batteryLevel }}%</div>
            </div>
            <div class="text-center">
                <svg-icon type="mdi" :path="mdiThermometer" class="text-orange-500" size="12"/>
                <div class="text-xs">{{ temperature }}°</div>
            </div>
            <div class="text-center">
                <svg-icon type="mdi" :path="mdiWaterPercent" class="text-blue-500" size="12"/>
                <div class="text-xs">{{ humidity }}%</div>
            </div>
            <div class="text-center">
                <svg-icon type="mdi" :path="mdiWeatherWindy" class="text-gray-500" size="12"/>
                <div class="text-xs">{{ windSpeed }}</div>
            </div>
        </div>
        
        
        <div class="grid grid-cols-4 gap-1">
            <div class="text-center">
                <svg-icon type="mdi" :path="mdiArrowExpandVertical" class="text-purple-500" size="12"/>
                <div class="text-xs">{{ height }}m</div>
            </div>
            <div class="text-center">
                <svg-icon type="mdi" :path="mdiDownload" :class="sdrDownQualityColor" size="12"/>
                <div class="text-xs" :class="sdrDownQualityColor">{{ sdrDownQuality }}%</div>
            </div>
            <div class="text-center">
                <svg-icon type="mdi" :path="mdiUpload" :class="sdrUpQualityColor" size="12"/>
                <div class="text-xs" :class="sdrUpQualityColor">{{ sdrUpQuality }}%</div>
            </div>
            <div class="text-center">
                <svg-icon type="mdi" :path="mdiClockOutline" class="text-gray-400" size="12"/>
                <div class="text-xs">{{ lastUpdate }}</div>
            </div>
        </div>
    </div>
    -->
    <div class="flex flex-auto w-full bg-base-100 text-xs rounded-sm px-1">



        <span class="rounded-sm bg-base-300 px-1 mx-1 flex items-center group relative">
            <svg-icon type="mdi" :path="mdiBatteryCharging" size="12" class="mr-1" />
            <span>{{ droneBattery }}</span>
            <span
                class="absolute bottom-full left-translate-x-1/2 mb-1 px-2  py-1 rounded bg-black text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200">
                Bateria del dron
            </span>
        </span>

        <span class="rounded-sm bg-base-300 px-1 mx-1 flex items-center group relative">
            <svg-icon type="mdi" :path="mdiArrowUpBold" size="12" class="mr-1" />
            <span>{{ sdrUpQuality }}</span>
            <span
                class="absolute bottom-full left-translate-x-1/2 mb-1 px-2  py-1 rounded bg-black text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200">
                Calidad de enlace de subida
            </span>
        </span>

        <span class="rounded-sm bg-base-300 px-1 mx-1 flex items-center group relative">
            <svg-icon type="mdi" :path="mdiArrowDownBold" size="12" class="mr-1" />
            <span>{{ sdrDownQuality }}</span>
            <span
                class="absolute bottom-full left-translate-x-1/2 mb-1 px-2  py-1 rounded bg-black text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200">
                Calidad de enlace de bajada
            </span>
        </span>





    </div>
</template>

<script setup>
/* eslint-disable */
import { computed } from 'vue'
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiWeatherWindy, mdiArrowUpBold, mdiArrowDownBold, mdiBatteryCharging } from '@mdi/js'


const props = defineProps({
    telemetry: {
        type: Object,
        default: () => ({})
    },
    isOnline: {
        type: Boolean,
        default: false
    }
})

const batteryLevel = computed(() => {
    return props.telemetry.battery_percentage || props.telemetry.battery || 0
})

const batteryColor = computed(() => {
    const level = batteryLevel.value
    if (level > 50) return 'text-success'
    if (level > 20) return 'text-warning'
    return 'text-error'
})

const temperature = computed(() => {
    return props.telemetry.temperature || 0
})

const humidity = computed(() => {
    return props.telemetry.humidity || 0
})

const windSpeed = computed(() => {
    return Math.floor(props.telemetry.wind_speed * 10) / 10 || 0
})

const height = computed(() => {
    return props.telemetry.height || 0
})

const sdrDownQuality = computed(() => {
    return props.telemetry['sdr.down_quality'] || 0
})

const sdrUpQuality = computed(() => {
    return props.telemetry['sdr.up_quality'] || 0
})

const droneBattery = computed(() => {
    const mode_code = props.telemetry["mode_code"];
    if (mode_code == 0) {
        return Math.floor(props.telemetry["drone_charge_state.capacity_percent"])
    } else {
        return "N/A"
    }
})

const sdrDownQualityColor = computed(() => {
    const quality = sdrDownQuality.value
    if (quality >= 80) return 'text-success'
    if (quality >= 60) return 'text-warning'
    return 'text-error'
})

const sdrUpQualityColor = computed(() => {
    const quality = sdrUpQuality.value
    if (quality >= 80) return 'text-success'
    if (quality >= 60) return 'text-warning'
    return 'text-error'
})

const lastUpdate = computed(() => {
    if (!props.telemetry.timestamp) return 'N/A'
    return new Date(props.telemetry.timestamp).toLocaleTimeString()
})
</script>